const baseUrl = trimEndSlash(appSettings["Integrations:SAG:BaseAddress"]);
const environment = trimEndSlash(appSettings["Integrations:SAG:Environment"]);
const sagSubscriptionKey = appSettings["Integrations:SAG:SubscriptionKey"];

function trimEndSlash(s: string) {
    return s?.replace(/\/*$/, "");
}

function getSagApiUrl(apiName: string, version?: string) {
    return `${baseUrl}/${apiName}/${environment ? environment + "/" : ""}${version ? version + "/" : ""}`;
}

export function useSagOptions() {
    return {
        getSagApiUrl,
        sagSubscriptionKey,
    };
}
